"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLendingAPI = exports.fetchLendingAPIJSON = exports.LapiError = exports.API_AUTH_TOKEN = void 0;
exports.API_AUTH_TOKEN = "Token iwoca-9e4606290c6294a6b40e15c9bb75cd2daf0";
class LapiError extends Error {
    constructor(statusCode, rawResponse) {
        super(rawResponse);
        this.name = "LapiError";
        this.statusCode = statusCode;
    }
}
exports.LapiError = LapiError;
function fetchLendingAPIJSON(path, { method = "get", query, body, overrideHeaders, } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield fetchLendingAPI(path, {
            method,
            query,
            body,
            overrideHeaders,
        });
        if (!res.ok) {
            throw new LapiError(res.status, yield res.text());
        }
        return yield res.json();
    });
}
exports.fetchLendingAPIJSON = fetchLendingAPIJSON;
function fetchLendingAPI(path, { method = "get", query, body, overrideHeaders, } = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const queryString = getQueryString(query);
        const url = `${path}${queryString}`;
        const res = yield getFetchFunctionByMethod(method)({
            url,
            body,
            headers: overrideHeaders,
        });
        if (!res.ok) {
            throw new LapiError(res.status, yield res.text());
        }
        return res;
    });
}
exports.fetchLendingAPI = fetchLendingAPI;
function getQueryString(query) {
    if (!query)
        return "";
    const normalisedQuery = normaliseQuery(query);
    const queryString = new URLSearchParams(normalisedQuery);
    return `?${queryString.toString()}`;
}
function normaliseQuery(query) {
    const queryParams = Object.entries(query)
        .filter(([_, value]) => {
        if (!value)
            return false;
        return true;
    })
        .map(([key, value]) => {
        if (Array.isArray(value)) {
            return [key, value.join(",")];
        }
        return [key, String(value)];
    });
    return Object.fromEntries(queryParams);
}
function getFetchFunctionByMethod(method) {
    switch (method) {
        case "get":
            return getLendingApiJson;
        case "post":
            return postLendingApiJson;
        case "put":
            return putLendingApiJson;
    }
}
function getLendingApiJson({ url, headers }) {
    return fetch(url, {
        credentials: "same-origin",
        headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8" }, headers),
    });
}
function postLendingApiJson({ url, body, headers }) {
    return fetch(url, Object.assign({ method: "POST", credentials: "same-origin", headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8", "x-csrftoken": getCookie("csrftoken") }, headers) }, (body && { body: JSON.stringify(body) })));
}
function putLendingApiJson({ url, body, headers }) {
    return fetch(url, {
        method: "PUT",
        credentials: "same-origin",
        headers: Object.assign({ "Content-Type": "application/json;charset=UTF-8", "x-csrftoken": getCookie("csrftoken") }, headers),
        body: JSON.stringify(body),
    });
}
function getCookie(name) {
    var _a, _b;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
        return (_b = (_a = parts === null || parts === void 0 ? void 0 : parts.pop()) === null || _a === void 0 ? void 0 : _a.split(";")) === null || _b === void 0 ? void 0 : _b.shift();
}
